export const gridBaseProps = {
  width: '100%',
  height: 350,
  showToolbar: true,
  showTitle: false,
  centered: false,
  defaultMargin: 0,
  defaultPadding: 10,
  sx: {
    boxShadow: 2,
    borderColor: '#ccc',
  },
};
